import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import { inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';
import type UserRole from 'volta/models/user-role';

export default class UserRoleSelect extends DomainSelect<UserRole, {}> {

  get idKey() {
    return 'id';
  }

  get propertyKey() {
    return 'name';
  }

  get infiniteScroll() {
    return true;
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'name'
    };
    const filter: IJsonApiQuery['filter'] = {};

    if (search && search.length) {
      filter['name'] = lkFilter(search);
    }
    if (selected && selected.length) {
      filter['selectedIds'] = inFilter(selected);
    } else if (excluded && excluded.length) {
      // This case should happen only when selected is empty
      filter['excludedIds'] = niFilter(excluded);
    }
    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      'user-role',
      decorateApiQuery(decoratedQuery),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    UserRoleSelect: typeof UserRoleSelect;
    'user-role-select': typeof UserRoleSelect;
  }
}
